import { useState } from "react";
import axios from "axios";
import { Field, inputCls, textareaCls, CheckboxGroup, Honeypot } from "@/components/FormControls";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const interestOptions = [
  "Consulting",
  "Mentoring",
  "Training",
  "Troubleshooting",
  "Evaluating",
  "Assessments",
  "Project work",
  "Advising",
  "Not sure yet",
];

const availabilityOptions = [
  "Occasional projects",
  "A few hours per month",
  "About one day per week",
  "Several days per month",
  "Remote/phone consulting",
  "In-person consulting",
  "Not sure yet",
];

export const AdvisorForm = ({ onSuccess }) => {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", city: "",
    experience_area: "", years_experience: "",
    learning: "", strengths: "", help_requests: "", teach_afternoon: "",
    interests: [], availability: [], website: "",
  });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus("submitting");
    setError("");
    try {
      await axios.post(`${API}/advisor-applications`, form);
      setStatus("success");
      onSuccess();
      window.scrollTo(0, 0);
    } catch (err) {
      setStatus("idle");
      setError("Something went wrong sending your information. Please check the required fields and try again.");
    }
  };

  return (
    <form onSubmit={submit} className="mt-12 space-y-8" data-testid="advisor-form">
      <Field label="Name" id="name" required>
        <input id="name" data-testid="advisor-name-input" className={inputCls} value={form.name} onChange={set("name")} required />
      </Field>
      <div className="grid gap-8 sm:grid-cols-2">
        <Field label="Email" id="email" required>
          <input id="email" type="email" data-testid="advisor-email-input" className={inputCls} value={form.email} onChange={set("email")} required />
        </Field>
        <Field label="Phone" id="phone">
          <input id="phone" type="tel" data-testid="advisor-phone-input" className={inputCls} value={form.phone} onChange={set("phone")} />
        </Field>
      </div>
      <div className="grid gap-8 sm:grid-cols-2">
        <Field label="City" id="city">
          <input id="city" data-testid="advisor-city-input" className={inputCls} value={form.city} onChange={set("city")} />
        </Field>
        <Field label="Approximate years of experience" id="years">
          <input id="years" data-testid="advisor-years-input" className={inputCls} value={form.years_experience} onChange={set("years_experience")} />
        </Field>
      </div>
      <Field label="Previous occupation or area of experience" id="experience_area">
        <input id="experience_area" data-testid="advisor-occupation-input" className={inputCls} value={form.experience_area} onChange={set("experience_area")} />
      </Field>
      <Field label="Tell us what you've spent your career or life learning." id="learning">
        <textarea id="learning" data-testid="advisor-learning-textarea" className={textareaCls} value={form.learning} onChange={set("learning")} />
      </Field>
      <Field label="What were you especially good at?" id="strengths">
        <textarea id="strengths" data-testid="advisor-strengths-textarea" className={textareaCls} value={form.strengths} onChange={set("strengths")} />
      </Field>
      <Field label="What did coworkers, customers, friends or family regularly ask you for help with?" id="help_requests">
        <textarea id="help_requests" data-testid="advisor-help-requests-textarea" className={textareaCls} value={form.help_requests} onChange={set("help_requests")} />
      </Field>
      <Field label="What could you teach someone in an afternoon?" id="teach_afternoon">
        <textarea id="teach_afternoon" data-testid="advisor-teach-textarea" className={textareaCls} value={form.teach_afternoon} onChange={set("teach_afternoon")} />
      </Field>

      <CheckboxGroup
        legend="I would be interested in:"
        options={interestOptions}
        values={form.interests}
        onChange={(v) => setForm({ ...form, interests: v })}
        testId="advisor-interest"
      />
      <CheckboxGroup
        legend="Availability:"
        options={availabilityOptions}
        values={form.availability}
        onChange={(v) => setForm({ ...form, availability: v })}
        testId="advisor-availability"
      />

      <Honeypot value={form.website} onChange={(v) => setForm({ ...form, website: v })} />

      {error && (
        <p className="text-destructive text-lg font-semibold" role="alert" data-testid="advisor-error-message">
          {error}
        </p>
      )}

      <button
        type="submit"
        data-testid="share-experience-submit-button"
        disabled={status === "submitting"}
        className="w-full sm:w-auto bg-secondary text-secondary-foreground text-xl font-semibold px-12 py-5 rounded-full transition-[background-color,transform] duration-300 hover:bg-[#caa95c] hover:-translate-y-0.5 disabled:opacity-60"
      >
        {status === "submitting" ? "SENDING..." : "SHARE MY EXPERIENCE"}
      </button>
    </form>
  );
};
